import { IAction, SET_FILTERS } from 'components/Screen';

import { FILTERS, METRICS } from './constants';

export { SET_FILTERS } from 'components/Screen';

export const SET_METRICS = 'SET_METRICS';

export default function screenReducer(state = {}, action: IAction) {
  switch (action.type) {
    case SET_FILTERS:
      return {
        ...state,
        [FILTERS]: action.payload,
      };
    case SET_METRICS:
      return {
        ...state,
        [METRICS]: action.payload,
      };

    default:
      return state;
  }
}
